import React, { useLayoutEffect, useRef } from "react"
import cx from "classnames"

export interface ProgressBarProps {
  children: React.ReactNode
  progress: number
  status?: "info" | "success" | "error"
  size: 32 | 48 | 64 | 96
  animated?: boolean
  className?: string
}

export const ProgressCircular = ({
  progress,
  size,
  status = "info",
  animated = false,
  className,
  children,
}: ProgressBarProps) => {
  const pathRef = useRef<SVGGeometryElement>(null)

  useLayoutEffect(() => {
    if (!pathRef.current) return
    const length = pathRef.current.getTotalLength()

    const value = progress

    const to = length * ((100 - value) / 100)
    // Trigger Layout in Safari hack https://jakearchibald.com/2013/animated-line-drawing-svg/
    pathRef.current.getBoundingClientRect()

    pathRef.current.style.strokeDashoffset = "" + Math.max(0, to)
  }, [])

  return (
    <div
      className={cx(
        `cobalt-circularProgressBar cobalt-circularProgressBar--size${size}`,
        className,
        {
          "cobalt-circularProgressBar--animated": animated,
          [`cobalt-circularProgressBar--${status}`]: status,
        }
      )}
    >
      <div className="cobalt-circularProgressBar__content">{children}</div>
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          ref={pathRef}
          className="cobalt-circularProgressBar__bar"
          d="M5,50a45,45 0 1,0 90,0a45,45 0 1,0 -90,0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDashoffset="282.78302001953125"
          strokeDasharray="282.78302001953125"
        />
      </svg>
    </div>
  )
}
